import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/PTLtoPackingApp';

const PTLtoPackingApp = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Switching PTL to Packing App</h3>
      </Col>
    </Row>
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

PTLtoPackingApp.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(PTLtoPackingApp);
